module.exports = __webpack_public_path__ + "static/postponed_ribbon-a5325bf11078f613f99c925ecad14c81.svg";